exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-journal_section{margin-bottom:70px}.c-journal_section .o-data-grid tbody tr td{padding:0}.c-journal_section .o-data-grid thead th{padding:0}.c-journal_section .c-common-info_row-inner-container{padding-left:158px}.c-journal_section .c-common-info_row-container{padding-top:24px;height:94px}", ""]);

// exports
